<!-- <p-dialog 
header="Enter Details"
[(visible)]="batchDialogVisible"
[modal]="true"
[closable]="true"             
[closeOnEscape]="true"   (onHide)="onBatchDialogClose()"    
[style]="{width: '80%', height: '60%'}">
    <div class="p-fluid" *ngIf="selectedBatchRow">
      <div class="p-fluid grid">
        <div class="field col-12 md:col-6" >
          <label style="margin-right: 0.5rem;">Input Roll No.:</label>
         
          <span *ngIf="selectedBatchRow?.get('woNo')?.value">
            {{ selectedBatchRow.get('woNo')?.value }}
          </span>
        </div>
          </div>
      <div class="p-fluid grid">
        <div class="field col-12 md:col-3">
          <label>Output Roll No</label>
          <input pInputText [(ngModel)]="selectedBatchRow.controls['batchNo'].value"
                 (ngModelChange)="selectedBatchRow.controls['batchNo'].setValue($event)">
        </div>
        <div class="field col-12 md:col-3"></div>
        <div class="field col-12 md:col-2"></div>

        
        <div class="field col-12 md:col-4">
          <label>Input Roll Wt.</label>
          <input type="number" class="disp-field" placeholder="0" pInputText
                 [(ngModel)]="selectedBatchRow.controls['dialogInputRoll'].value"
                 (ngModelChange)="selectedBatchRow.controls['dialogInputRoll'].setValue($event)" />
        </div>
        
        </div>

        <div class="p-fluid grid">
      <div class="field col-12 md:col-3">
        <label>Gross Wt.</label>
        <input pInputText [(ngModel)]="selectedBatchRow.controls['dialogGross'].value"
               (ngModelChange)="selectedBatchRow.controls['dialogGross'].setValue($event)">
      </div>
      <div class="field col-12 md:col-3">
        <label>Core Wt.</label>
        <input pInputText [(ngModel)]="selectedBatchRow.controls['dialogCore'].value"
        (ngModelChange)="selectedBatchRow.controls['dialogCore'].setValue($event)">
      </div>

      <div class="field col-12 md:col-2"></div>

      <div class="field col-12 md:col-4">
        <label>Used Wt.</label>
        <input type="number" class="disp-field" placeholder="0" pInputText
               [(ngModel)]="selectedBatchRow.controls['dialogUsed'].value"
               (ngModelChange)="selectedBatchRow.controls['dialogUsed'].setValue($event)" />
      </div>
      
      </div>

     

      <div class="p-fluid grid">
        <div class="field col-12 md:col-3">
          <label>Net Wt.</label>
          <input pInputText type="number" [(ngModel)]="selectedBatchRow.controls['dialogNet'].value"
                 (ngModelChange)="selectedBatchRow.controls['dialogNet'].setValue($event)">
        </div>
        <div class="field col-12 md:col-3">
          <label>Meter</label>
          <input pInputText [(ngModel)]="selectedBatchRow.controls['dialogMeter'].value"
        (ngModelChange)="selectedBatchRow.controls['dialogMeter'].setValue($event)">
        </div>

        <div class="field col-12 md:col-2"></div>

      <div class="field col-12 md:col-4">
        <label>Scrap Wt.</label>
        <input type="number" class="scrp" placeholder="0" pInputText
               [(ngModel)]="selectedBatchRow.controls['dialogScrap'].value"
               (ngModelChange)="selectedBatchRow.controls['dialogScrap'].setValue($event)" />
      </div>
        </div>

        <div class="p-fluid grid">
          <div class="field col-12 md:col-3">
            <label>Color Shade</label>
            <input pInputText  [(ngModel)]="selectedBatchRow.controls['dialogColor'].value"
                   (ngModelChange)="selectedBatchRow.controls['dialogColor'].setValue($event)">
          </div>
          <div class="field col-12 md:col-3">
            <label>Text Matter</label>
            <input pInputText  [(ngModel)]="selectedBatchRow.controls['dialogText'].value"
                   (ngModelChange)="selectedBatchRow.controls['dialogText'].setValue($event)">
          </div>

          <div class="field col-12 md:col-2"></div>


          <div class="field col-12 md:col-4">
            <label>Input Roll Balanced Wt.</label>
            <input type="number" class="disp-field" placeholder="0" pInputText
                   [(ngModel)]="selectedBatchRow.controls['dialogInBlnWt'].value"
                   (ngModelChange)="selectedBatchRow.controls['dialogInBlnWt'].setValue($event)" />
              </div>
     
          </div>

      <div class="p-fluid grid">
      <div class="field col-12 md:col-6">
        <label>Remark</label>
        <textarea pInputTextarea [(ngModel)]="selectedBatchRow.controls['remark'].value"
                  (ngModelChange)="selectedBatchRow.controls['remark'].setValue($event)"></textarea>
      </div>

      <div class="field col-12 md:col-2"></div>


      <div class="field col-12 md:col-4">
        <label>Ink Gain Wt.</label>
        <input type="number" class="disp-field" placeholder="0" pInputText
               [(ngModel)]="selectedBatchRow.controls['dialogInk'].value"
               (ngModelChange)="selectedBatchRow.controls['dialogInk'].setValue($event)" />
          </div>
      </div>
    </div>
   
      <button pButton label="OK" icon="pi pi-check" (click)="addBatchToList()"></button>
 

    

    <p-table
  [value]="selectedMaterialRow?.get('batches')?.value || []"
  [responsive]="true"
>
  <ng-template pTemplate="header">
    <tr>
      <th>Output Roll</th>
      <th>Gross</th>
      <th>Core</th>
      <th>Net Wt.</th>
      <th>Meter</th>
      <th>Color Shade</th>
      <th>Text Matter</th>
      <th>Remark</th>

      

      <th>Action</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-row let-i="rowIndex">
    
      <tr (dblclick)="editBatchRow(row, i)" pTooltip="Double-click to view this roll">
      <td>{{ row.batchNo }}</td>
      <td>{{ row.dialogGross }}</td>
      <td>{{ row.dialogCore }}</td>
      <td>{{ row.dialogNet }}</td>
      <td>{{ row.dialogMeter }}</td>
      <td>{{ row.dialogColor }}</td>
      <td>{{ row.dialogText }}</td>
      <td>{{ row.remark }}</td>

      

      <td>
       
        <button pButton icon="pi pi-pencil" class="p-button-sm p-button-text"
                (click)="editBatchRow(row, i)"></button>
  
       
        <button pButton icon="pi pi-trash" class="p-button-sm p-button-text p-button-danger"
                (click)="deleteBatchRow(i)"></button>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="footer">
    <tr>
      <td colspan="3" style="text-align: right;"><strong>Total</strong></td>
      <td><strong>{{ netWeightTotal }}</strong></td>
      <td colspan="4"></td>
    </tr>

    
  </ng-template>
</p-table>

  </p-dialog> -->

  <!-- Custom Dialog Wrapper -->
<div class="custom-dialog-backdrop" *ngIf="batchDialogVisible" (keydown.escape)="onBatchDialogClose()" tabindex="0">
    <div class="custom-dialog">
      <!-- Header -->
      <div class="custom-dialog-header">
        <h3>Enter Details</h3>
        <button class="close-btn" (click)="onBatchDialogClose()">×</button>
      </div>
  
      <!-- Body -->
      <div class="custom-dialog-body" *ngIf="selectedBatchRow">
        <!-- First Row -->
        <div class="form-row">
          <label>Input Roll No.:</label>
          <span *ngIf="selectedBatchRow?.get('woNo')?.value">
            {{ selectedBatchRow.get('woNo')?.value }}
          </span>
        </div>

        <div class="form-row">
          <label>Input Roll Wt:</label>
          <input type="number"
                 [value]="selectedBatchRow.controls['dialogInputRoll'].value"
                 (input)="selectedBatchRow.controls['dialogInputRoll'].setValue($event.target.value)">
        </div>
  
        <!-- Second Row -->
        <div class="form-row">
          <label>Output Roll No:</label>
          <input type="text"
                 [value]="selectedBatchRow.controls['batchNo'].value"
                 (input)="selectedBatchRow.controls['batchNo'].setValue($event.target.value)">
        </div>
  
       
  
        <!-- Add similar fields below as needed -->
        <!-- <div class="form-row">
          <label>Gross Wt.:</label>
          <input type="number"
                 [value]="selectedBatchRow.controls['dialogGross'].value"
                 (input)="selectedBatchRow.controls['dialogGross'].setValue($event.target.value)">
        </div>
  
        <div class="form-row">
          <label>Core Wt.:</label>
          <input type="number"
                 [value]="selectedBatchRow.controls['dialogCore'].value"
                 (input)="selectedBatchRow.controls['dialogCore'].setValue($event.target.value)">
        </div>
  
        <div class="form-row">
          <label>Net Wt.:</label>
          <input type="number"
                 [value]="selectedBatchRow.controls['dialogNet'].value"
                 (input)="selectedBatchRow.controls['dialogNet'].setValue($event.target.value)">
        </div> -->
        <div class="form-row">
          <label>Output Kgs</label>
          <input type="number"
                 [value]="selectedBatchRow.controls['dialogColor'].value"
                 (input)="selectedBatchRow.controls['dialogColor'].setValue($event.target.value)">
        </div>
  
        <div class="form-row">
          <label>Meters</label>
          <input type="number"
                 [value]="selectedBatchRow.controls['dialogMeter'].value"
                 (input)="selectedBatchRow.controls['dialogMeter'].setValue($event.target.value)">
        </div>
  
        <div class="form-row">
          <label>Flag</label>
          <input type="number"
                 [value]="selectedBatchRow.controls['dialogText'].value"
                 (input)="selectedBatchRow.controls['dialogText'].setValue($event.target.value)">
        </div>
  
        <div class="form-row">
          <label>Wastage</label>
          <input type="number" [value]="selectedBatchRow.controls['remark'].value"
                    (input)="selectedBatchRow.controls['remark'].setValue($event.target.value)">
         
        </div>
  
        <!-- Add your other fields here similarly -->
  
        <button class="btn btn-outline-success " (click)="addBatchToList()">Save Roll</button>

        <!-- <div *ngIf="selectedMaterialRow?.get('batches')?.value?.length > 0" class="card mt-3"> -->
          <div *ngIf="selectedMaterialRow" class="card mt-3">
            <div class="card-body table-responsive">
              <h5>Rolls</h5>
              <table class="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th>Output Roll</th>
                    <!-- <th>Gross</th>
                    <th>Core</th>
                    <th>Net Wt.</th> -->
                    <th>Output Kgs</th>
                    <th>Meter</th>
                   
                    <th>Flag</th>
                    <th>Wastage</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let batch of selectedMaterialRow.get('batches')?.value; let i = index">
                    <td>{{ batch.batchNo }}</td>
                    <!-- <td>{{ batch.dialogGross }}</td>
                    <td>{{ batch.dialogCore }}</td>
                    <td>{{ batch.dialogNet }}</td> -->

                    <td>{{ batch.dialogColor }}</td>
                    <td>{{ batch.dialogMeter }}</td>
                   
                    <td>{{ batch.dialogText }}</td>
                    <td>{{ batch.remark }}</td>
                    <td>
                      <button class="btn btn-sm btn-primary" (click)="editBatchRow(batch, i)">Edit</button>
                      <button class="btn btn-sm btn-danger" (click)="deleteBatchRow(i)">Delete</button>
                    </td>
                  </tr>
                </tbody>

                <tfoot *ngIf="selectedMaterialRow.get('batches')?.value?.length > 0">
                  <tr>
                    <td style="font-weight: bold;">Total</td>
                    <td style="font-weight: bold;">
                      {{ getBatchTotal('dialogColor') }}
                    </td>
                    <td style="font-weight: bold;">
                      {{ getBatchTotal('dialogMeter') }}
                    </td>

                    
                    <td style="font-weight: bold;">
                      {{ getBatchTotal('dialogText') }}
                    </td>
                    <td style="font-weight: bold;">
                      {{ getBatchTotal('remark') }}
                    </td>
                    <td colspan="4"></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          
      </div>
    </div>
  </div>



  <!-- Inking Dialog -->
<!-- Inking Dialog -->
<div class="custom-dialog-backdrop inking-dialog" *ngIf="inkingDialogVisible" tabindex="0">
  <div class="custom-dialog inking-dialog">
    <div class="custom-dialog-header">
      <h3>Inking Details</h3>
      <button class="close-btn" (click)="closeInkingDialog()">×</button>
    </div>

    <div class="custom-dialog-body">

      <!-- Single Input Row -->
      <!-- <div class="form-row mb-3"> -->
        <div class="d-flex flex-wrap gap-2 mb-3">

       
        <!-- <input type="text" placeholder="Ink Name" [(ngModel)]="currentInk.inkName" class="form-control me-2 mb-2" /> -->
        <select class="form-select" [(ngModel)]="currentInk.inkName" style="max-width: 32%;">
          <option value="" disabled selected>Select Ink Name</option>
          <option value="INK PEONY">INK PEONY</option>
          <option value="INK ALPINE">INK ALPINE</option>
          <option value="VIOLET">VIOLET</option>
          <option value="MAGENTA">MAGENTA</option>
          <option value="INK BOPP">INK BOPP</option>
          <option value="INK POLY">INK POLY</option>
        </select>
        <!-- <input type="text" placeholder="Ink Color" [(ngModel)]="currentInk.inkColor" class="form-control me-2 mb-2" /> -->
        <select class="form-select scrollable-dropdown" [(ngModel)]="currentInk.inkColor" style="max-width: 32%;">
          <option value="" disabled selected>Select Ink Color</option>
          <option value="CYAN">CYAN</option>
          <option value="RED">RED</option>
          <option value="BLACK">BLACK</option>
          <option value="BLUE">BLUE</option>
          <option value="GREEN">GREEN</option>
          <option value="GOLD">GOLD</option>
          <option value="MAGETA">MAGETA</option>
          <option value="ORANGE">ORANGE</option>
          <option value="MEDIUM">MEDIUM</option>
          <option value="REFLEX">REFLEX</option>
          <option value="VIOLET">VIOLET</option>
          <option value="WHITE">WHITE</option>
          <option value="VANISH">VANISH</option>
          <option value="BROWN">BROWN</option>
          <option value="YELLOW">YELLOW</option>
          <option value="OPV">OPV</option>
          <option value="HARDNER">HARDNER</option>
        </select>
        <!-- <input type="text" placeholder="Ink Type" [(ngModel)]="currentInk.inkType" class="form-control me-2 mb-2" /> -->
        <select class="form-select" [(ngModel)]="currentInk.inkType" style="max-width: 32%;">
          <option value="" disabled selected>Select Ink Type</option>
          <option value="Mixed">Mixed</option>
          <option value="Fresh">Fresh</option>
        </select>

        </div>

        <div class="d-flex flex-wrap gap-2 mb-3">
        <input type="text" placeholder="Issue (Kgs)" [(ngModel)]="currentInk.issue" class="form-control me-2 mb-2" style="max-width: 33%;"/>
        <input type="text" placeholder="Return (Kgs)" [(ngModel)]="currentInk.return" class="form-control me-2 mb-2" style="max-width: 33%;"/>
      </div>

      <!-- Save Button -->
      <!-- <div class="text-end mb-3">
        <button class="btn btn-success" (click)="saveInking()">Save Inking</button>
      </div> -->
      <!-- with edit -->
       <!-- Save / Update Button -->
      <div class="text-end mb-3">
        <button class="btn btn-success" (click)="saveInking()">
          {{ editingIndex === -1 ? 'Save Inking' : 'Update Inking' }}
        </button>
      </div>

      <!-- Display Saved Inking Entries -->
      <!-- <div *ngIf="inkingData.length > 0"> -->
        <h5>Inking Summary</h5>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Ink Name</th>
              <th>Ink Color</th>
              <th>Ink Type</th>
              <th>Issue (Kgs)</th>
              <th>Return (Kgs)</th>

              <th>Liquid Cons</th>
<th>Solid %</th>
<th>Solid Cons</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr *ngFor="let ink of inkingData"> -->
              <tr *ngIf="inkingData.length === 0">
                <td colspan="6" class="text-center text-muted">No ink records added yet.</td>
              </tr>
              <tr *ngFor="let ink of inkingData; let i = index">
              <td>{{ ink.inkName }}</td>
              <td>{{ ink.inkColor }}</td>
              <td>{{ ink.inkType }}</td>
              <td>{{ ink.issue }}</td>
              <td>{{ ink.return }}</td>

               <!-- Liquid Cons: Issue - Return -->
  <td>{{ getLiquidCons(ink) }}</td>
  
  <!-- Solid % (editable) -->
  <td>
    <input type="number" [(ngModel)]="ink.solidPercent" class="form-control" style="max-width: 80px;" (ngModelChange)="updateSolidCons(ink)"/>
  </td>

  <!-- Solid Cons: (solid% * liquidCons) / 100 -->
  <td>{{ getSolidCons(ink) }}</td>

              <td>
                <button class="btn btn-sm btn-primary me-2" (click)="editInk(i)">Edit</button>
                <button class="btn btn-sm btn-danger" (click)="deleteInk(i)">Delete</button>
              </td>
            </tr>
          </tbody>

          <tfoot *ngIf="inkingData.length">
            <tr style="font-weight: bold;">
              <td colspan="3" class="text-end">Total</td>
              <td>{{ getInkTotal('issue') | number: '1.2-2' }}</td>
              <td>{{ getInkTotal('return') | number: '1.2-2' }}</td>
              <td>{{ getTotalLiquidCons() | number: '1.2-2' }}</td>
              <td></td>
              <td>{{ getTotalSolidCons() | number: '1.2-2' }}</td>
              <td></td>
            </tr>
          </tfoot>
          
        </table>
        <!-- to make table visible even when empty -->
      <!-- </div> -->

    </div>
  </div>
</div>



<div class="custom-dialog-backdrop inking-dialog" *ngIf="breakdownDialogVisible" tabindex="0">
  <div class="custom-dialog breakdown-dialog">
    <div class="custom-dialog-header">
      <h3>Breakdown Details</h3>
      <button class="close-btn" (click)="closeBreakdownDialog()">×</button>
    </div>

    <div class="custom-dialog-body">

      <!-- Input Form -->
      <div class="form-row mb-3">
        <select class="form-select me-2" [(ngModel)]="currentBreakdown.downTime">
          <option value="" disabled selected>Select DownTime</option>
          <option value="Breakdown">Breakdown</option>
          <option value="JCO">JCO</option>
          <option value="Cylinder Clean">Cylinder Clean</option>
          <option value="D/B Change">D/B Change</option>
          <option value="Splice Fail">Splice Fail</option>
          <option value="Power Fail">Power Fail</option>
          <option value="AW Approval">AW Approval</option>
          <option value="Shade Approval">Shade Approval</option>
          <option value="No Operator">No Operator</option>
          <option value="Maintenance">Maintenance</option>
          <option value="Material Shortage">Material Shortage</option>
        </select>
        <!-- <input type="text" placeholder="Time" [(ngModel)]="currentBreakdown.downTimeTime" class="form-control me-2" /> -->
        <select class="form-select me-2" [(ngModel)]="currentBreakdown.downTimeTime">
          <option value="" disabled selected>Select Time (Minutes)</option>
          <option *ngFor="let minute of fixedMinutes" [value]="minute">{{ minute }}</option>
        </select>
        <input type="text" placeholder="Remarks" [(ngModel)]="currentBreakdown.downTimeRemarks" class="form-control me-2" />
      </div>

      <!-- Save / Update Button -->
      <div class="text-end mb-3">
        <button class="btn btn-success" (click)="saveBreakdown()">
          {{ breakdownEditingIndex === -1 ? 'Save Breakdown' : 'Update Breakdown' }}
        </button>
      </div>

      <!-- Breakdown Table -->
      <h5>Breakdown Summary</h5>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>DownTime</th>
            <th>Time</th>
            <th>Remarks</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="breakdownData.length === 0">
            <td colspan="4" class="text-center text-muted">No breakdown records added yet.</td>
          </tr>
          <tr *ngFor="let breakdown of breakdownData; let i = index">
            <td>{{ breakdown.downTime }}</td>
            <td>{{ breakdown.downTimeTime }}</td>
            <td>{{ breakdown.downTimeRemarks }}</td>
            <td>
              <button class="btn btn-sm btn-primary me-2" (click)="editBreakdown(i)">Edit</button>
              <button class="btn btn-sm btn-danger" (click)="deleteBreakdown(i)">Delete</button>
            </td>
          </tr>
        </tbody>

        <tfoot *ngIf="breakdownData.length > 0">
          <tr class="fw-bold">
            <td colspan="1" class="text-end">Total</td>
            <td>{{ getTotalDownTime() }}</td>
            <td colspan="2"></td>
          </tr>
        </tfoot>
        
      </table>

    </div>
  </div>
</div>



<div class="custom-dialog-backdrop inking-dialog" *ngIf="solventDialogVisible" tabindex="0">
  <div class="custom-dialog solvent-dialog inking-dialog">
    <div class="custom-dialog-header">
      <h3>Solvent Details</h3>
      <button class="close-btn" (click)="closeSolventDialog()">×</button>
    </div>

    <div class="custom-dialog-body">

      <!-- Input Fields -->
      <!-- <div class="form-row mb-3">
        <input type="text" placeholder="E/A" [(ngModel)]="currentSolvent.ea" class="form-control me-2" />
        <input type="text" placeholder="TOL" [(ngModel)]="currentSolvent.tol" class="form-control me-2" />
        <input type="text" placeholder="IPA" [(ngModel)]="currentSolvent.ipa" class="form-control me-2" />
      </div> -->
      <!-- Input Fields in one row -->
<div class="d-flex flex-wrap gap-2 mb-3">
  <!-- <input type="text" placeholder="solvent Type" [(ngModel)]="currentSolvent.solType" class="form-control me-2" style="max-width: 32%;" /> -->
  <select class="form-select me-2" [(ngModel)]="currentSolvent.solType" style="max-width: 32%;">
    <option value="" disabled>Select Solvent Type</option>
    <option value="TOL">TOL</option>
    <option value="IPA">IPA</option>
    <option value="E/A">E/A</option>
    <option value="MIX">MIX</option>
  </select>

  
  <input type="text" placeholder=" solvent Issue" [(ngModel)]="currentSolvent. solIssue" class="form-control me-2" style="max-width: 32%;" />
  <input type="text" placeholder="solvent Return" [(ngModel)]="currentSolvent.solReturn" class="form-control me-2" style="max-width: 32%;" />
</div>


      <!-- Save / Update Button -->
      <div class="text-end mb-3">
        <button class="btn btn-success" (click)="saveSolvent()">
          {{ solventEditingIndex === -1 ? 'Save Solvent' : 'Update Solvent' }}
        </button>
      </div>

      <!-- Solvent Summary Table -->
      <h5>Solvent Summary</h5>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Solvent Type</th>
            <th>Issue Qty</th>
            <th>Return Qty</th>
            <th>Consumption</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="solventData.length === 0">
            <td colspan="5" class="text-center text-muted">No solvent records added yet.</td>
          </tr>
          <tr *ngFor="let solvent of solventData; let i = index">
            <td>{{ solvent.solType }}</td>
            <td>{{ solvent.solIssue }}</td>
            <td>{{ solvent.solReturn }}</td>

            <td>{{ calculateConsumption(solvent) }}</td>
            <td>
              <button class="btn btn-sm btn-primary me-2" (click)="editSolvent(i)">Edit</button>
              <button class="btn btn-sm btn-danger" (click)="deleteSolvent(i)">Delete</button>
            </td>
          </tr>
        </tbody>

         <!-- Totals Row -->
  <tfoot *ngIf="solventData.length > 0">
    <tr class="fw-bold">
      <td>Total</td>
      <td>{{ getTotalSolvent('solIssue') }}</td>
      <td>{{ getTotalSolvent('solReturn') }}</td>
      <td>{{ getTotalConsumption() }}</td>
      <td></td>
    </tr>
  </tfoot>
      </table>

    </div>
  </div>
</div>




  



  <h5>Printing Productions</h5>
 
  <div class="card mb-4">
  <div class="card-body">
  <!-- <form [formGroup]="printingForm" (ngSubmit)="savetodatabase()" (keydown.enter)="$event.preventDefault()"> -->
    <form [formGroup]="printingForm"  (ngSubmit)="onSubmit()" (keydown.enter)="$event.preventDefault()">
   

      <div class="custom-tabs mb-3">
        <button
        type="button"
        class="custom-tab"
        [class.active]="basicInfoVisible"
        (click)="basicInfoVisible = !basicInfoVisible"
      >
        Basic Info
      </button>
      </div>
      


      <div *ngIf="basicInfoVisible">
        <div class="row">

            <div class="col form-group mb-3">
                <label for="ticketNo">Ticket No</label>
                <input type="text" id="ticketNo" formControlName="ticketNo" class="form-control" />
            </div>

            <div class="col form-group mb-3">
                <label for="refNo">Ref No</label>
                <input type="text" id="refNo" formControlName="refNo" class="form-control" />
            </div>

            <div class="col form-group mb-3">
                <label for="poNumber">PO Number</label>
                <input type="text" id="poNumber" formControlName="poNumber" class="form-control" />
            </div>

        </div>

        <div class="row">
            <div class="col form-group mb-3">
                <label for="clientName">Client Name</label>
                <input type="text" id="clientName" formControlName="clientName" class="form-control" />
            </div>

            <div class="col form-group mb-3">
                <label for="jobName">Job Name</label>
                <input type="text" id="jobName" formControlName="jobName" class="form-control" />
            </div>

            <div class="col form-group mb-3">
                <label for="orderKgs">Order Kgs</label>
                <input type="number" id="orderKgs" formControlName="orderKgs" class="form-control" />
            </div>
        </div>

       
    
    
    <!--Shift info-->
    <!-- <h5 class="text-center font-bold font-up danger-text">Shift Information</h5> -->
    <div class="row">
        <div class="col-3 col form-group mb-3">
            <label class="form-label">Shift</label>
            <select class="form-select" formControlName="shift" required>
                <option value="" disabled selected>Select Shift</option>
                <option value="A">A</option>
                <option value="B">B</option>
                <option value="C">C</option>
                <option value="A 12">A 12</option>
                <option value="B 12">B 12</option>
            </select>
        </div>
        <div class="col-3 col form-group mb-3">
            <label for="machine" class="form-label">Machine</label>
            <select class="form-select" formControlName="machine" required>
                <option value="" disabled selected>Select Machine</option>
                <option value="P1-ROTO">P1-ROTO</option>
                <option value="P2-ROTO">P2-ROTO</option>
                <option value="P3-ROTO">P3-ROTO</option>
                <option value="P4-ROTO">P4-ROTO</option>
                <option value="P5-ROTO">P5-ROTO</option>
                <option value="P6-ROTO">P6-ROTO</option>
            </select>
        </div>
        <div class="col-3 col form-group mb-3">
            <label for="operator" class="form-label">Operator</label>
            <select class="form-select" formControlName="operator" id="operator" >
                <option value="" disabled selected>Select Operator</option>
                <option value="Chandrakan" selected="">Chandrakan</option>
                <option value="ASAMOAH">ASAMOAH</option>
                <option value="BERTHA">BERTHA</option>
                <option value="Brigh">Brigh</option>
                <option value="Chandrakan">Chandrakan</option>
                <option value="Daniel">Daniel</option>
                <option value="Deepak">Deepak</option>
                <option value="DEEPAK B">DEEPAK B</option>
            </select>
        </div>
        <div class="col-3 col form-group mb-3">
            <label for="operatingTime" class="form-label">Operating time</label>
            <input type="text" formControlName="operatingTime" id="operatingTime" class="form-control"
                readonly disabled />
        </div>
    </div>
    <div class="row">
        <div class="col form-group mb-3">
            <label for="timeFrom" class="form-label">Time From</label>
            <input type="time" formControlName="timeFrom" id="timeFrom" class="form-control" />

            <!-- for hour interval -->
            <!-- <select formControlName="timeFrom" id="timeFrom" class="form-control">
        <option *ngFor="let time of hourIntervals" [value]="time">{{ time }}</option>
      </select> -->
        </div>
        <div class="col form-group mb-3">
            <label for="timeTo" class="form-label">Time To</label>
            <input type="time" formControlName="timeTo" id="timeTo" class="form-control" />
            <!-- <select formControlName="timeTo" id="timeTo" class="form-control">
        <option *ngFor="let time of hourIntervals" [value]="time">{{ time }}</option>
      </select> -->
        </div>
        <div class="col form-group mb-3">
            <label for="mcSpeed" class="form-label">MC Speed (RPM)</label>
            <input type="text" formControlName="mcSpeed" id="mcSpeed" class="form-control" />
        </div>
        <div class="col form-group mb-3">
            <label for="inkGsm" class="form-label">Ink GSM</label>
            <input type="text" formControlName="inkGsm" id="inkGsm" class="form-control" />
        </div>

    </div>

    <hr>
    </div>

   
   
   




       <!-- table -->
       <div class="card p-fluid">
        <div class="table-responsive-wrapper">
          <div class="table-responsive">
            <table class="table table-bordered" id="productionTable">
              <thead>
                <tr>
                  <th>Serial No</th>
                  <th>Input Roll No</th>
                  <th>Joint</th>
                  <th>Kgs</th>
                  <th>Return</th>
                 
                  <th>Wastage</th>
                  <th>Output Roll</th>


                  <th>Total Output Kgs</th>
                  <th>Total Output Meters</th>
                  <th>Total Output Flags</th>
                  <th>Total Output Wastage</th>
                 
                  
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of materialDetails.controls; let i = index" [formGroup]="row">
                  <td>{{ i + 1 }}</td>
                  <td><input type="text" class="form-control" formControlName="woNo" required placeholder="Input Roll" (click)="openPwDialog()" /></td>
                  <td><input type="text" class="form-control" formControlName="itemWidth" placeholder="Joint" /></td>
                  <td><input type="text" class="form-control" formControlName="itemGross" placeholder="Kgs" /></td>
                  <td><input type="text" class="form-control" formControlName="itemThickness" placeholder="Return" /></td>
                 

                  <td><input type="text" class="form-control" formControlName="itemWastage" placeholder="Wastage" /></td>

                  
                  <td><input type="text" class="form-control orange" [value]="row.controls['batchNo'].value" readonly placeholder="Click Here" (click)="openBatchDialog(row)" /></td>


                  <td><input type="text" class="form-control" formControlName="itemInk" placeholder="Output kgs" /></td>
                  <td><input type="text" class="form-control" formControlName="itemScrap" placeholder="Output Meters" /></td>
                  <td><input type="text" class="form-control" formControlName="itemUsed" placeholder="Output Flags" /></td>
                  <td><input type="text" class="form-control" formControlName="itemBalanced" placeholder="Output Wastage" /></td>
                
                  <td><button type="button" class="btn btn-danger btn-sm" (click)="removeRow(i)">Remove</button></td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="2" style="text-align: right; font-weight: bold;">Total:</td>
                  <td><strong>{{ getTotal('itemWidth') }}</strong></td>
                
                  <td><strong>{{ getTotal('itemGross') }}</strong></td>
                  <td><strong>{{ getTotal('itemThickness') }}</strong></td>
                  <td><strong>{{ getTotal('itemWastage') }}</strong></td>

                  <td></td>
                  <!-- <td><strong>{{ totalInkGainWt | number:'1.2-2' }}</strong></td>
                  <td><strong>{{ totalScrapWt | number:'1.2-2' }}</strong></td>
                  <td><strong>{{ totalUsedWt | number:'1.2-2' }}</strong></td>
                  <td><strong>{{ totalBalancedWt | number:'1.2-2' }}</strong></td> -->
                  <!-- out kgs -->
                  <td><strong>{{ getTotal('itemInk') }}</strong></td>
                  <!-- out meters -->
                  <td><strong>{{ getTotal('itemScrap') }}</strong></td>
                  <!-- out flags -->
                  <td><strong>{{ getTotal('itemUsed') }}</strong></td>
                  <!-- wastage -->
                  <td><strong>{{ getTotal('itemBalanced') }}</strong></td>
                 
                  <td></td>
                </tr>



                <!--  -->
                <tr>
                  <td colspan="3" style="text-align: right; font-weight: bold;">Balance Return :</td>
                  <td>{{ (getTotal('itemThickness') ) | number: '1.2-2' }}</td>
                  <td colspan="2"></td>
                  <td colspan="0" style="text-align: right; font-weight: bold;">Wastage :</td>
                  <td>{{ (getTotal('itemBalanced') ) | number: '1.2-2' }}</td>
                  <td colspan="3"></td>
                </tr>
                <!--  -->

                <!--  -->
                <tr>
                  <td colspan="3" style="text-align: right; font-weight: bold;">Net Consumption :</td>
                  <td>{{ (getTotal('itemGross') - getTotal('itemThickness')) | number: '1.2-2' }}</td>
                  <td colspan="2"></td>
                  <td colspan="0" style="text-align: right; font-weight: bold;">Total Output :</td>
                  <td>{{ (getTotal('itemInk') - getTotal('itemBalanced')) | number: '1.2-2' }}</td>
                  <td colspan="3"></td>
                </tr>
                <!--  -->
              </tfoot>
            </table>
          </div>
        </div>

        <div class="row">
            <div class="col">
        <button type="button" class="btn btn-primary button-roll" (click)="addRow()">Add Roll</button>
        </div>
        </div>
      </div>
      
        <!--  -->

        <button type="submit" class="btn btn-primary mt-3" 
      
      >Submit</button>




</form>

<div class="d-flex justify-content-end gap-2 mt-3">
  <!-- btn btn-outline-secondary -->
  <button type="button" class="btn btn-outline-success button-g" (click)="openInkingDialog()">Ink Details</button>

  <button type="button" class="btn btn-danger" (click)="openBreakdownDialog()">Capture Breakdown</button>

  <button type="button" class="btn btn-primary" (click)="openSolventDialog()"  style="background-color:#77beeb;">Solvent</button>

  
  <button 
  class="btn btn-success mt-2" 
  [disabled]="!submittedData"
  (click)="exportToExcel()">
  Download Excel
</button>
  <!-- <button 
  *ngIf="submittedData" 
  class="btn btn-success mt-2" 
  (click)="exportToExcel()">
  Download Excel
</button> -->
</div>




</div>
</div>